"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAnchorsOnPage = exports.isAnchorNode = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _hsanchor = require("../constants/hsanchor");

var isAnchorNode = function isAnchorNode(node) {
  if (!node) return false;
  return node.nodeName === 'A' && !node.href && (node.id || node.name) && !node.getAttribute('data-insert') // Temporary link inserts have this attr
  ;
}; // Synchronous Fetch:
// Fetch all the anchors on the page, or the one(s) that match the {anchorId}. This will
// potentially grab anchors from other rich text modules as long as they have the [data-hs-anchor]


exports.isAnchorNode = isAnchorNode;

var fetchAnchorsOnPage = function fetchAnchorsOnPage(editor) {
  var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var doc = editor.getDoc();
  var anchorEls = (0, _toConsumableArray2.default)(doc.querySelectorAll("a[" + _hsanchor.HS_ANCHOR_ATTRIBUTE + "]")).filter(function (anchor) {
    return !!anchor.id && anchor.id.indexOf(search) >= 0;
  });
  return anchorEls;
};

exports.fetchAnchorsOnPage = fetchAnchorsOnPage;